<template>
  <div :ref="setMainRef" class="page-container">
    <DashboardToolbar :setting="state.setting" @toggle-fullscreen="toggleFullScreen(mainRef)" @toggle-setting="toggleSetting" />
    <DashboardHeader :name="state.name" :setting="state.setting" @change-name="changeName" />

    <div class="page-content">
      <DashboardSidePanel
        :slots="leftSlots"
        :layout="state.layout"
        :kpi-data="state.kpiData"
        :setting="state.setting"
        :format-widget-props="formatWidgetProps"
        :set-slot-ref="setSlotRef"
        @edit-slot="openKpiSelect"
      />

      <DashboardCenterPanel
        :layout="state.layout"
        :safe-up-days="state.safeUpDays"
        :setting="state.setting"
        :map-options="state.mapOptions"
        :map-runtime="state.mapRuntime"
        :sorted-map-ids="sortedMapIds"
        :kpi-data="state.kpiData"
        :set-risk-map-ref="setRiskMapRef"
        :format-widget-props="formatWidgetProps"
        @toggle-map="toggleMapSelection"
        @edit-meters="openKpiSelect('meters')"
      />

      <DashboardSidePanel
        :slots="rightSlots"
        :layout="state.layout"
        :kpi-data="state.kpiData"
        :setting="state.setting"
        :format-widget-props="formatWidgetProps"
        :set-slot-ref="setSlotRef"
        @edit-slot="openKpiSelect"
      />
    </div>

    <KpiSelectDialog
      v-model:visible="kpiSelect.visible"
      :multiple="kpiSelect.multiple"
      :options="kpiOptions"
      :form="kpiSelect.form"
      :values="kpiSelect.values"
      @change-kpi-id="handleKpiIdChange"
      @confirm="confirmKpiSelect"
    />
  </div>
</template>

<script setup>
import { computed, onMounted, onUnmounted } from 'vue'
import { CHART_SLOTS } from './config/slots'
import { useDashboard } from './composables/useDashboard'
import DashboardToolbar from './components/DashboardToolbar.vue'
import DashboardHeader from './components/DashboardHeader.vue'
import DashboardSidePanel from './components/DashboardSidePanel.vue'
import DashboardCenterPanel from './components/DashboardCenterPanel.vue'
import KpiSelectDialog from './components/KpiSelectDialog.vue'

const {
  state,
  mainRef,
  kpiSelect,
  kpiOptions,
  sortedMapIds,
  setSlotRef,
  formatWidgetProps,
  loadDashboard,
  changeName,
  openKpiSelect,
  handleKpiIdChange,
  confirmKpiSelect,
  toggleMapSelection,
  toggleSetting,
  toggleFullScreen,
  observe,
  disconnect,
  setRiskMapRef
} = useDashboard()

const leftSlots = computed(() => CHART_SLOTS.filter((slot) => slot.side === 'left'))
const rightSlots = computed(() => CHART_SLOTS.filter((slot) => slot.side === 'right'))
const setMainRef = (el) => {
  mainRef.value = el
}

onMounted(async () => {
  await loadDashboard()
  observe(mainRef.value)
})

onUnmounted(disconnect)
</script>

<style lang="scss" scoped>
.page-container {
  width: 100%;
  height: 100%;
  background-position: center;
  background-size: cover;
  background-image: url('@/assets/dashboard/bg.webp');
  box-sizing: border-box;
  position: relative;
  user-select: none;
}
.page-content {
  height: calc(100% - 80px);
  display: flex;
  padding: 10px;
  box-sizing: border-box;
}
:deep(.rolling-board .job-time),
:deep(.rolling-board .job-user),
:deep(.rolling-board .job-name),
:deep(.rolling-board .job-area) {
  color: #00b1f3;
}
</style>
